const listAttributes = ['location', 'roomId', 'label'] as const;
const getAttributes = [...listAttributes] as const;

export const RoomAttributes = {
  List: listAttributes,
  Get: getAttributes,
};
